export const baseApiEndpoint =
  import.meta.env.VITE_APP_BASE_URL || 'https:/vimc.com.vn';
